import { Study, StudyType } from '@/shared/api/protocol-ts/model/dto_study_pb';

export const hasReportPhoto = (studies?: Study[]): boolean =>
  studies?.some((study) => study.Type === StudyType.StudyType_DentalPhoto) ??
  false;
